export function debounce(fn: Function, wait: number) {
    let timer: number | undefined = undefined;
    return function (...args: any[]) {
        if (timer) {
            clearTimeout(timer); // clear any pre-existing timer
        }
        //@ts-ignore
        const context = this; // get the current context
        timer = window.setTimeout(() => {
            fn.apply(context, args); // call the function if time expires
        }, wait);
    };
}
